import { isNativeApp } from './platform';

const LAST_CHECK_KEY = 'mt_rides_update_checked_at';
const CHECK_EVERY_MS = 24 * 60 * 60 * 1000;

/** Play flexible in-app update — only on native Play installs. */
export const checkForAppUpdate = async () => {
  if (!isNativeApp()) return;
  try {
    const last = Number(localStorage.getItem(LAST_CHECK_KEY) || 0);
    if (last && Date.now() - last < CHECK_EVERY_MS) return;
    localStorage.setItem(LAST_CHECK_KEY, String(Date.now()));
    const { registerPlugin } = await import('@capacitor/core');
    const AppUpdate = registerPlugin('AppUpdate');
    if (AppUpdate?.checkAndStartFlexible) {
      await AppUpdate.checkAndStartFlexible();
    }
  } catch (e) {
    console.warn('app update check failed:', e?.message || e);
  }
};
